import { useState } from "react";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import EditorialMarquee from "../components/EditorialMarquee";
import Fleet from "../components/Fleet";
import Manifesto from "../components/Manifesto";
import TourInfo from "../components/TourInfo";
import Testimonials from "../components/Testimonials";
import Locations from "../components/Locations";
import Footer from "../components/Footer";
import BookViaText from "../components/BookViaText";
import FloatingBookButton from "../components/FloatingBookButton";
import ScrollingTalon from "../components/ScrollingTalon";

export default function Home() {
  const [bookOpen, setBookOpen] = useState(false);
  return (
    <div className="bg-black text-white" data-testid="home-page">
      <Navbar onOpenBookText={() => setBookOpen(true)} />
      <Hero onOpenBookText={() => setBookOpen(true)} />
      <EditorialMarquee />
      <Fleet onOpenBookText={() => setBookOpen(true)} />
      <Manifesto />
      <TourInfo />
      <Testimonials />
      <Locations />
      <Footer onOpenBookText={() => setBookOpen(true)} />
      <ScrollingTalon />
      <FloatingBookButton onOpen={() => setBookOpen(true)} />
      <BookViaText open={bookOpen} onClose={() => setBookOpen(false)} />
    </div>
  );
}
